import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, X } from 'lucide-react';

interface AdjustmentBannerProps {
  message: string;
  visible: boolean;
  onDismiss: () => void;
}

export function AdjustmentBanner({ message, visible, onDismiss }: AdjustmentBannerProps) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="border-l-4 border-gold-500 bg-dark-surface rounded-r-lg px-4 py-3 mb-4 flex items-start gap-3"
          initial={{ opacity: 0, y: -20, height: 0 }}
          animate={{ opacity: 1, y: 0, height: 'auto' }}
          exit={{ opacity: 0, y: -20, height: 0 }}
          transition={{ duration: 0.25, ease: 'easeInOut' }}
        >
          <Sparkles size={18} className="text-gold-400 shrink-0 mt-0.5" />
          <p className="text-sm text-content-secondary font-body flex-1">{message}</p>
          <button
            onClick={onDismiss}
            className="text-content-muted hover:text-content transition-colors shrink-0"
          >
            <X size={16} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
